/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SignalAlarmRules
 */
export interface SignalAlarmRules {
  /**
   *
   * @type {string}
   * @memberof SignalAlarmRules
   */
  signalAlarmRulesId?: string;
  /**
   *
   * @type {string}
   * @memberof SignalAlarmRules
   */
  signalNamePrefix?: string;
  /**
   *
   * @type {number}
   * @memberof SignalAlarmRules
   */
  businessDayThreshold?: number;
  /**
   *
   * @type {string}
   * @memberof SignalAlarmRules
   */
  description?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalAlarmRules
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalAlarmRules
   */
  updatedAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the SignalAlarmRules interface.
 */
export function instanceOfSignalAlarmRules(
  value: object,
): value is SignalAlarmRules {
  return true;
}

export function SignalAlarmRulesFromJSON(json: any): SignalAlarmRules {
  return SignalAlarmRulesFromJSONTyped(json, false);
}

export function SignalAlarmRulesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SignalAlarmRules {
  if (json == null) {
    return json;
  }
  return {
    signalAlarmRulesId:
      json["signalAlarmRulesId"] == null
        ? undefined
        : json["signalAlarmRulesId"],
    signalNamePrefix:
      json["signalNamePrefix"] == null ? undefined : json["signalNamePrefix"],
    businessDayThreshold:
      json["businessDayThreshold"] == null
        ? undefined
        : json["businessDayThreshold"],
    description: json["description"] == null ? undefined : json["description"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
  };
}

export function SignalAlarmRulesToJSON(json: any): SignalAlarmRules {
  return SignalAlarmRulesToJSONTyped(json, false);
}

export function SignalAlarmRulesToJSONTyped(
  value?: SignalAlarmRules | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    signalAlarmRulesId: value["signalAlarmRulesId"],
    signalNamePrefix: value["signalNamePrefix"],
    businessDayThreshold: value["businessDayThreshold"],
    description: value["description"],
    createdAt: value["createdAt"],
    updatedAt: value["updatedAt"],
  };
}
